import styled from "styled-components"

import Card from "@irati/ui/src/Layout/Card"
import {WorkSansBold} from "@irati/ui/src/global/fonts"

export const Bold = styled.span`
  ${WorkSansBold}
`

export const LeftAlign = styled.div`
  text-align: left;
`

export const TopCard = styled(Card)`
  box-shadow: none;
  text-align: center;
`

export const GreyCard = styled(Card)`
  background-color: ${({theme}) => theme.colors.greys.light};
`

export const InnerCard = styled(Card)`
  margin: 15px 0;
`

export const LoadingWrapper = styled.div`
  padding: 170px 0 230px 0;
`
